import {Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';

const tipTitleSx = { fontWeight: 600, color: '#333', fontSize: 13 };
const tipExampleSx = { color: '#888', fontSize: 12.5 };

const TIPS = [
    {
        title: '1. 문서 제목에 질문 키워드를 포함하세요.',
        body: 'AI는 문서 제목을 가장 먼저 검색합니다. 사용자가 입력할 만한 질문을 제목에 그대로 넣어주세요.',
        example: (
            <>
                예) <s>안녕</s> → <b>부정 청탁</b>
            </>
        )
    },
    {
        title: '2. 답변에도 질문 키워드를 한 번 더 써주세요.',
        body: '답변 첫 문장에 질문의 핵심 단어를 다시 언급하면 검색 정확도가 올라갑니다.',
        example: (
            <>
                예) "안됩니다." → "<b>부정 청탁</b>을 받았을 때는 즉시 거절 의사를 표시합니다."
            </>
        )
    },
    {
        title: '3. 카테고리를 정확히 분류해 주세요.',
        body: null,
        example: null
    }
];

export default function FaqWritingTips() {
    return (
        <Accordion
            disableGutters
            elevation={0}
            sx={{
                backgroundColor: '#fafafa',
                border: '1px solid #ececec',
                borderRadius: '8px',
                '&:before': { display: 'none' }
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ fontSize: 20, color: '#888' }} />}
                sx={{ minHeight: 44, '& .MuiAccordionSummary-content': { my: 1 } }}
            >
                <Stack direction='row' alignItems='center' spacing={1}>
                    <TipsAndUpdatesOutlinedIcon sx={{ fontSize: 18, color: '#f5a623' }} />
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#444' }}>
                        AI 답변 정확도를 높이는 작성 팁
                    </Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0, pb: 2, px: 2.5 }}>
                <Stack spacing={1.25} sx={{ fontSize: 13, color: '#555', lineHeight: 1.6 }}>
                    {TIPS.map((tip) => (
                        <Box key={tip.title}>
                            <Typography component='span' sx={tipTitleSx}>{tip.title}</Typography>
                            <Box sx={{ pl: 1.5, mt: 0.25 }}>
                                {tip.body}
                                {tip.example && (
                                    <>
                                        <br />
                                        <Typography component='span' sx={tipExampleSx}>
                                            {tip.example}
                                        </Typography>
                                    </>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
}
